/* CUSTOM: Impact Board status filter — marks the clicked status button active and hides .custom-impact-board-item tiles whose data-status does not match.
   Loaded with defer from snippets/custom-page-impact-board.liquid, which renders the #custom-impact-board-filter form and the tiles. */
(() => {
  const init = () => {
    const boardFilter = document.getElementById('custom-impact-board-filter');

    if (!boardFilter) {
      return;
    }

    const buttons = boardFilter.querySelectorAll('.custom-impact-board-status-button');
    const items = document.querySelectorAll('.custom-impact-board-item');

    const applyFilters = () => {
      const activeButton = boardFilter.querySelector('.custom-impact-board-status-button.active');
      const selectedStatus = activeButton ? activeButton.getAttribute('data-status') : '';

      items.forEach((item) => {
        const itemStatus = item.getAttribute('data-status');
        const showItem = !selectedStatus || itemStatus === selectedStatus;

        item.hidden = !showItem;
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((currentButton) => {
          currentButton.classList.remove('active');
        });

        button.classList.add('active');
        applyFilters();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
